var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../sutl';
import { AsciiText } from './framework/AsciiText';
import { Timeouts } from './framework/Timeouts';
export class OnkyoRz {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        this.volumeRange = { max: 100, min: 30 };
        this.volumeRanges = {
            'TX-RZ800': { max: 100, min: 30 },
            'TX-RZ900': { max: 100, min: 30 },
            'TX-RZ610': { max: 100, min: 30 },
            'TX-RZ620': { max: 100, min: 30 },
            'TX-RZ630': { max: 100, min: 30 },
            'TX-RZ710': { max: 200, min: 60 },
            'TX-RZ720': { max: 200, min: 60 },
            'TX-RZ730': { max: 200, min: 60 },
            'TX-RZ740': { max: 200, min: 60 },
            'TX-RZ810': { max: 200, min: 60 },
            'TX-RZ820': { max: 200, min: 60 },
            'TX-RZ830': { max: 200, min: 60 },
            'TX-RZ840': { max: 200, min: 60 },
            'TX-RZ920': { max: 200, min: 60 },
            'TX-RZ1100': { max: 200, min: 60 },
            'TX-RZ3100': { max: 200, min: 60 },
            'TX-RZ5100': { max: 200, min: 60 },
        };
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1FWVQSTN`), /FWV(.+)/i, tags);
                return match[1];
            }),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1FWVQSTN`), /FWV(.+)|FWVN\/A/i);
                return match[1] !== undefined;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1PWRQSTN`), /!1PWR0(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1PWR0${power ? 1 : 0}`), /!1PWR0(\d)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 6500 : 2000);
                return match[1] === '1';
            }),
            asyncHandlers: [
                {
                    regExp: /!1PWR0(\d)/i,
                    callback: (match) => {
                        this.state.power.update(match[1] === '1');
                    },
                },
            ],
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1SLIQSTN`), /SLI([0-9a-f]+)/i, tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1SLI${value}`), /SLI([0-9a-f]+)|SLIN\/A/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2500);
                if (match[1])
                    return match[1];
                return this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /SLI([0-9a-f]+)/i,
                    callback: (match) => {
                        const value = match[1];
                        this.state.videoMatrixRoutes.update('1', value);
                    },
                },
            ],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1MVLQSTN`), /!1MVL([0-9a-f]+)/i, tags);
                return parseInt(match[1], 16);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1MVL${volume.toString(16).toUpperCase().padStart(2, '0')}`), /!1MVL([0-9a-f]+)|!1MVLN\/A/i, tags);
                if (match[1])
                    return parseInt(match[1], 16);
                return this.state.volume.value;
            }),
            range: (config) => __awaiter(this, void 0, void 0, function* () {
                return Object.assign(Object.assign({}, this.volumeRange), { round: 1 });
            }),
            asyncHandlers: [
                {
                    regExp: /!1MVL([0-9a-f]+)/i,
                    callback: (match) => {
                        const volume = parseInt(match[1], 16);
                        this.state.volume.update(volume);
                    },
                },
            ],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1AMTQSTN`), /!1AMT0(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(this.makeCommand(`!1AMT0${mute ? '1' : '0'}`), /!1AMT0(\d)|!1AMTN\/A/i, tags);
                if (match[1])
                    return match[1] === '1';
                return this.state.volumeMute.value;
            }),
            asyncHandlers: [
                {
                    regExp: /!1AMT0(\d)/i,
                    callback: (match) => {
                        const mute = match[1] === '1';
                        this.state.volumeMute.update(mute);
                    },
                },
            ],
        };
        // polling
        this.polls = [
            { intervalMs: 4000, controls: ['power', 'videoMatrixRoutes'], onePerInterval: true },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.amxBeaconHandlerId !== undefined) {
                this.socket.unregisterAsync(this.amxBeaconHandlerId);
                this.amxBeaconHandlerId = undefined;
            }
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            // Use power query to confirm connection.
            try {
                yield this.socket.send(this.makeCommand('!1PWRQSTN'), /!1PWR(\d+)/i);
            }
            catch (err) {
                return 'verifyFailed';
            }
            // We use the AMX beacon to detect the model number which we use to get the volume range.
            // The AMX beacon can be queried via RS-232 but not on Ethernet. On Ethernet, the beacon is
            // automatically sent every 30-60 seconds, so for that case we register an async handler to
            // parse the AMX beacon and reconfigure the volume range if it is different than our initial
            // guess.
            if (this.socket.port === 4999) {
                const match = yield this.socket.send(this.makeCommand('AMX'), /AMXB<.+Model=(.+)><-Revision.+/);
                const model = match[1];
                const newVolumeRange = this.volumeRanges[model];
                if (newVolumeRange !== undefined)
                    this.volumeRange = newVolumeRange;
            }
            else {
                this.amxBeaconHandlerId = this.socket.registerAsync({
                    name: 'amxBeaconHandler',
                    regExp: /AMXB<.+Model=(.+)><-Revision.+/i,
                    callback: (match) => {
                        if (this.amxBeaconHandlerId !== undefined) {
                            this.socket.unregisterAsync(this.amxBeaconHandlerId);
                            this.amxBeaconHandlerId = undefined;
                        }
                        const model = match[1];
                        const newVolumeRange = this.volumeRanges[model];
                        if (newVolumeRange !== undefined &&
                            !Sutl.objEquals(this.volumeRange, newVolumeRange)) {
                            this.volumeRange = newVolumeRange;
                            this.framework.changePhase('configuring');
                        }
                    },
                });
            }
            return 'connected';
        });
    }
    // other class methods
    makeCommand(data) {
        if (this.socket.port === 60128) {
            // ISCP + header size
            const bytes = [0x49, 0x53, 0x43, 0x50, 0x00, 0x00, 0x00, 0x10, 0x00, 0x00, 0x00];
            const length = data.length;
            bytes.push(length);
            bytes.push(0x01); // version
            bytes.push(0x00);
            bytes.push(0x00);
            bytes.push(0x00); // reserved
            for (let i = 0; i < length; i++) {
                bytes.push(data.charCodeAt(i) & 0x0ff);
            }
            return AsciiText.decode(bytes);
        }
        else {
            return data;
        }
    }
}
// static properties
OnkyoRz.driverType = 'socketDriver';
OnkyoRz.key = '-LvG5s2whBBxCDDA1EC6';
OnkyoRz.baseSocketOptions = {
    sendTerminator: '\r',
};
OnkyoRz.socketOptions = [
    Object.assign(Object.assign({}, OnkyoRz.baseSocketOptions), { port: 60128, commandExtractor: {
            terminators: [''],
            unterminatedRegExp: /.+\x1A\r\n/i,
        } }),
    Object.assign(Object.assign({}, OnkyoRz.baseSocketOptions), { port: 4999, commandExtractor: {
            terminators: ['\x1A'],
        } }),
];
